export const tabs = (t: (key: string) => string) => [
  { label: t('common.labels.details'), to: '../details' },
  { label: t('common.tabs.audit_logs'), to: '../audit-logs' },
];
